import React, { useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { AuthContext } from '../../contexts/auth.context';
import { ConfirmContext } from '../../contexts/confirm.context';
import { IBar } from '../../models/IBars';
import { ICustomer } from '../../models/ICustomers';
import { SideMenuItem } from '../../models/INav';
import DashboardPage from '../../pages/Dashboard/Dashboard.page';
import BarsService from '../../services/bar/bar.service';
import CustomerService from '../../services/customer/customer.service';

export const DUMMY_BAR: IBar = {
    id: '0',
    name: 'Mike’s hungry Pub',
    address: '8888 Mike’s lane Drive, CA',
    image: null as any,
    poc: {
        name: 'Mike Mikey',
        phone: '(333)-333-3333',
        email: 'mike@mail.com',
        address: '8888 Mike’s lane Drive, CA',
        role: 'Owner'
    }
};

export const DUMMY_CUSTOMER: ICustomer = {
    id: '0',
    firstName: 'John',
    lastName: 'Doe',
    email: 'Johndoe@mail.com'
};



export default function DashboardContainer() {


    const history = useHistory();
    let query = new URLSearchParams(useLocation().search);
    const { user: authUser, logout } = useContext(AuthContext);
    const { show } = useContext(ConfirmContext);

    const [open, setOpen] = React.useState(false);
    const [bsearchValue, setBSearchValue] = React.useState("");
    const [csearchValue, setCSearchValue] = React.useState("");

    const [bars, setBars] = React.useState<IBar[]>([]);
    const [searchedBars, setSearchedBars] = React.useState<IBar[]>([]);
    const [customers, setCustomers] = React.useState<ICustomer[]>([]);
    const [searchedCustomers, setSearchedCustomers] = React.useState<ICustomer[]>([]);


    const view = query.get("view") || "bars";

    useEffect(() => {
        Promise.all([
            BarsService.getBars().then(setBars),
            CustomerService.getCustomers().then(setCustomers)
        ])

    }, [])


    useEffect(() => {
        if (bsearchValue.length > 2) {
            BarsService.searchBars(bsearchValue)
                .then(setSearchedBars)
        }
        if (bsearchValue.length === 0) {
            setSearchedBars([])
        }

    }, [bsearchValue])

    useEffect(() => {
        if (csearchValue.length > 2) {
            CustomerService.searchCustomer(csearchValue)
                .then((ret) => {
                    console.log("the ret val ", ret)
                    setSearchedCustomers(ret) 
                })
        }
        if (csearchValue.length === 0) {
            setSearchedCustomers([])
        }

    }, [csearchValue])

    const deleteCustomer = (customerId: string) => {
        CustomerService.deleteCustomer(customerId);
    }

    const onCreateClick = () => {
        history.push("/manage-bar")
    }

    const onDetailsClick = (entry: IBar | ICustomer) => {
        if (view === "bars") {
            history.push(`/bar-details/${entry?.id}`);
        } else if (view === "customers") {
            history.push(`/customer-details/${entry?.id}`);
        }
    }

    const onDeleteCustomerClick = (entry: IBar & ICustomer) => {
        show({
            title: 'Delete customer',
            message: `Are you sure you want to delete ${entry?.firstName} ${entry.lastName}`,
            actions: [
                {
                    title: 'No',
                    role: 'cancel',
                    style: { color: '#fff' }
                },
                {
                    title: 'Yes',
                    role: 'destructive',
                    style: { backgroundColor: '#DF2727', color: '#fff' },
                    handler: () => deleteCustomer(entry.id)
                }
            ]
        });
    }

    const onDeleteBarClick = (entry: IBar) => {
        show({
            title: `Delete ${entry?.name}`,
            message: `Are you sure you want to delete ${entry?.name}`,
            actions: [
                {
                    title: 'No',
                    role: 'cancel',
                    style: { color: '#fff' }
                },
                {
                    title: 'Yes',
                    role: 'destructive',
                    style: { backgroundColor: '#DF2727', color: '#fff' },
                    handler: async () => {
                        await BarsService.deleteBar(entry.id);
                        setBars((prev) => prev.filter((bar) => bar.id !== entry.id));
                        setSearchedBars((prev) => prev.filter((bar) => bar.id !== entry.id));
                        history.replace("/dashboard?view=bars");
                    }
                }
            ]
        });
    }

    const onLogoutPress = () => {
        logout()
        history.replace("/login")

    }

    const navItems: SideMenuItem[] = [
        {
            label: "Bars",
            onClick: () => history.push("/dashboard?view=bars")
        },
        {
            label: "Customers",
            onClick: () => history.push("/dashboard?view=customers")
        },
        {
            label: "Happy Hour",
            onClick: () => history.push("/dashboard?view=happy-hour")
        },
        {
            label: "Logout",
            onClick: onLogoutPress
        },
    ];

    return (
        <DashboardPage
            open={open}
            setOpen={setOpen}
            barSearchValue={bsearchValue}
            setBarSearchValue={setBSearchValue}
            cusSearchValue={csearchValue}
            setCusSearchValue={setCSearchValue}
            bars={searchedBars.length ? searchedBars : bars}
            customers={searchedCustomers.length ? searchedCustomers : customers}
            view={view}
            navItems={navItems}
            onCreateClick={onCreateClick}
            onDetailsClick={onDetailsClick}
            onDeleteBarClick={onDeleteBarClick}
            onDeleteCustomerClick={onDeleteCustomerClick}
        />
    )
}
